import { COLORS } from 'styles/colors'

export const MILK_YIELD_LEGENDS = [
	{
		color: COLORS.blue,
		description: 'Товарное молоко',
	},
	{
		color: COLORS.error,
		description: 'Бракованное молоко',
	},
	{
		color: COLORS.icon,
		description: 'Нет данных',
	},
]

export const NO_DATA_TITLE = 'Нет данных'
export const NO_DATA_DESCRIPTION =
	'Нет данных, соответствующих заданным условиям'

export const SHIFT_LABELS = {
	am: 'Утренняя',
	pm: 'Дневная',
	night: 'Ночная',
}
